import { useMemo } from 'react';
import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { ACCOUNT_ISSUE_PATH, LOGIN_PATH, SITES_MANAGEMENT_HEADER } from '../../config';
import { AppLayout } from 'src/layouts';
import {
  NAV_ITEMS_HEADER_SITES_MANAGEMENT,
  getNavItemsHeaderSiutesManagementSAAndAA,
} from 'src/features';
import { SiteMapPage } from '../../pages';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { AccessRoles } from 'src/features/user-account-details/types';

export const SiteMapElement = ({ isSuperAdmin }: ElementProps) => {
  const { isCustomerAccessAllowed, loggedIn, customerId, getCurrentRole, user } =
    useAuthentication();

  const isAccountAdmin = getCurrentRole(customerId.value, null) === AccessRoles.ACCOUNT_ADMIN;

  const uniqueRedirectPath = useMemo(() => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isSuperAdmin && !isCustomerAccessAllowed.value)
      return isCustomerAccessAllowed.isCustomerActive
        ? ACCOUNT_ISSUE_PATH + '?reason=Access Denied'
        : ACCOUNT_ISSUE_PATH;
  }, [loggedIn, isSuperAdmin, isCustomerAccessAllowed]);

  const SiteMapRouteElement = useMemo(
    () => (
      <Protected
        isAuthenticated={loggedIn.value}
        isAuthorized={isSuperAdmin || isCustomerAccessAllowed.value}
        uniqueRedirectPath={uniqueRedirectPath}
      >
        <AppLayout
          headerTitle={SITES_MANAGEMENT_HEADER}
          headerNavItems={
            isSuperAdmin || isAccountAdmin
              ? getNavItemsHeaderSiutesManagementSAAndAA(user, isSuperAdmin)
              : NAV_ITEMS_HEADER_SITES_MANAGEMENT
          }
        >
          <SiteMapPage />
        </AppLayout>
      </Protected>
    ),
    [loggedIn, isSuperAdmin, isCustomerAccessAllowed, isAccountAdmin, user, uniqueRedirectPath]
  );

  const getSiteMapElement = () => {
    if (isSuperAdmin && loggedIn.loaded) return SiteMapRouteElement;

    if (!loggedIn.loaded) return <LoadingElement />;

    if (loggedIn.loaded && !loggedIn.value) return SiteMapRouteElement;

    if (!customerId.value || !customerId.loaded) return <LoadingElement />;

    if (!isCustomerAccessAllowed.loaded) return <LoadingElement />;

    return SiteMapRouteElement;
  };

  return getSiteMapElement();
};
